export const HOME_PAGE = '/';
export const VERIFY_PAGE = '/verify';
export const PROFILE_PAGE = '/profile';
export const PRIVACY_POLICY_PAGE = '/privacy-policy';
export const TERMS_AND_CONDITIONS_PAGE = '/terms-conditions';
export const FAQS_PAGE = '/faqs';
export const REFERRAL_PAGE = '/referral';
export const CONTEST_PAGE = '/contest';
export const GET_CONTEST_DETAILS_PAGE = id => `${CONTEST_PAGE}/${id}`;

